import { LINKS } from '@common/consts'

export function cdnImage(relPath) {
  return new URL(`/images/${relPath}`, LINKS.ASSETS_CDN_URL).toString()
}
